<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"
                         :class="[setBtnColor]"
                         :useBtnList="useBtnList"
                         @btnRetrieve="btnRetrieve()" @btnMakeInspectionRequest="btnMakeIns()" @btnReInspectionApply="btnReInspectionApply()"
                         @btnSaveRequest="btnSaveRequest()" @btnDelete="btnDelete()" @btnPrintSheet="btnPrintSheet()" >
          <template v-slot:body>
            <v-row>
              <v-col cols="12" class="pa-0">
                <i-card-top
                    class="d-md-flex"
                    outlined
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-0 pl-1">
                      <v-col cols="12">
                        <v-row dense>
                          <i-label :label="'Supplier name : '"/>
                          <v-col cols="4">
                            <v-select
                                v-model="supName"
                                :items="supNameList"
                                item-value="supName"
                                return-object
                                single-line
                                outlined
                                dense
                                @change="supNameChange"
                            ></v-select>
                          </v-col>
                          <i-label :label="'Search Info. '" class="pl-2"/>
                          <v-col cols="4">
                            <v-text-field
                                v-model="searchInfo"
                                dense
                                outlined
                                hide-details="auto"
                                height="32"
                                maxlength="100"
                            />
                          </v-col>
                          <v-col cols="full" align="right" class="pa-2">
                            <span class="pa-2 userManual" @click="manual()" >User Manual</span>
                          </v-col>
                        </v-row>
                        <v-row dense class="ma-0">
                          <i-label :label="'Division : '"/>
                          <v-col cols="1">
                            <v-select
                                v-model="inspDiv"
                                :items="inspDivList"
                                item-value="code"
                                item-text="codeName"
                                return-object
                                single-line
                                outlined
                                dense
                            ></v-select>
                          </v-col>
                          <v-col cols="1" class="pl-0">
                            <DxDateBox
                                :value="stDate"
                                height="30px"
                                display-format="yyyy-MM-dd"
                                :acceptCustomValue="false"
                                @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}"
                            />
                          </v-col>
                          <i-label :label="'Attend Insp : '" class="pl-2"/>
                          <v-col cols="1" >
                            <v-select
                                v-model="attendInsp"
                                :items="attendInspList"
                                item-value="code"
                                item-text="codeName"
                                return-object
                                single-line
                                outlined
                                dense
                            ></v-select>
                          </v-col>
                          <i-label :label="'Result Insp : '" class="pl-2"/>
                          <v-col cols="3" >
                            <v-select
                                v-model="resultInsp"
                                :items="resultInspList"
                                item-value="insResCd"
                                item-text="insResNm"
                                return-object
                                single-line
                                outlined
                                dense
                            ></v-select>
                          </v-col>
                        </v-row>

                        <v-row dense class="ma-0">
                          <i-label :label="'Ship No : '"/>
                          <v-col cols="1">
                            <v-select
                                v-model="shipNo"
                                :items="shipNoList"
                                item-value="shipNo"
                                return-object
                                single-line
                                outlined
                                dense
                            ></v-select>
                          </v-col>
                          <i-label :label="'QM Part : '" class="pl-2"/>
                          <v-col cols="1" >
                            <v-select
                                v-model="qmPart"
                                :items="qmPartList"
                                item-value="code"
                                item-text="codeName"
                                return-object
                                single-line
                                outlined
                                dense
                                @change="getInspKindtList"
                            ></v-select>
                          </v-col>
                          <i-label :label="'Inspection Kind : '" class="pl-2"/>
                          <v-col cols="2" >
                            <v-select
                                v-model="inspKind"
                                :items="inspKindList"
                                item-value="kindCd"
                                item-text="kindNm"
                                return-object
                                single-line
                                outlined
                                dense
                            ></v-select>
                          </v-col>
                          <v-col cols="full" class="pa-2">
                            <span class="pa-1 inspection" >Re-Inspection</span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-1">
                <DxDataGrid id="v80a1080"
                            :ref="v80a1080Ref"
                            class="listBox10"
                            :data-source="gridMainList"
                            :remote-operations="false"
                            :hover-state-enabled="true"
                            :allow-column-resizing="true"
                            :allow-column-reordering="true"
                            :row-alternation-enabled="true"
                            :show-borders="true"
                            :width="grid.width"
                            :show-row-lines="true"
                            key-expr="id"
                            :focused-row-enabled="false"
                            :column-hiding-enabled="false"
                            :sorting="{ mode: 'none' }"
                            :selection="{ mode: 'none' }"
                            :word-wrap-enabled="true"
                            @cellPrepared="cellPrepared"
                            @editing-start="onEditingStart"
                >
                  <DxColumn data-field="selChek" data-type="boolean" width="40" header-cell-template="selHeader" cell-template="selChkRow" :allow-editing="false" />
                  <template #selHeader = "{ data: cellInfo }" >
                    <DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)"  />
                  </template>
                  <template #selChkRow = "{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                :onValueChanged="value => onValueChanged(value, cellInfo)"  />
                  </template>
                  <DxColumn data-field="ownNm" caption="Owner" width="120" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="shipNo" caption="Ship No" width="70" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="custNm" caption="Sub-Contract name" width="200" data-type="string" alignment="left" :allow-editing="false"/>
                  <DxColumn caption="Inspection" alignment="center">
                    <DxColumn data-field="porNoSeq" caption="POR NO" width="100" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="itemDesc" caption="Items" width="420" data-type="string" alignment="left" :allow-editing="false"/>
                    <DxColumn data-field="kindCd" caption="Insp. Kind" width="180" data-type="string" alignment="left" :allow-editing="true">
                      <DxLookup :data-source="inspKindList" display-expr="kindNm" value-expr="kindCd" />
                    </DxColumn>
                    <DxColumn data-field="qmNm" caption="QM Part" width="80" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="porQty" caption="Q'ty" width="50" data-type="string" alignment="center" :allow-editing="true"/>
                    <DxColumn data-field="resNm" caption="Result Insp." width="200" data-type="string" alignment="left" :allow-editing="false"/>
                    <DxColumn data-field="bomCnt" caption="BOM" width="50" data-type="string" cell-template="bomCnt" alignment="center" :allow-editing="false"/>
                  </DxColumn>
                  <template #bomCnt="{ data }">
                    <span @click="bomClick(data)" class="bomClick" >{{data.text}}</span>
                  </template>

                  <DxColumn caption="Req. Date" alignment="center">
                    <DxColumn data-field="reqDate" caption="Date" width="120" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="reqTime" caption="Time" width="80" data-type="string" alignment="center" :allow-editing="false">
                      <DxLookup :data-source="insTimeList" display-expr="timeNm" value-expr="codeName" />
                    </DxColumn>
                  </DxColumn>
                  <DxColumn caption="Insp. Date" alignment="center">
                    <DxColumn data-field="insDate" caption="Date" width="120" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="true"/>
                    <DxColumn data-field="insTime" caption="Time" width="80" data-type="string" alignment="center" :allow-editing="true">
                      <DxLookup :data-source="insTimeList" display-expr="timeNm" value-expr="codeName" />
                    </DxColumn>
                  </DxColumn>
                  <DxColumn caption="Attending" alignment="center">
                    <DxColumn data-field="wlq" caption="LQC" width="40" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="LQC" />
                    <DxColumn data-field="wqm" caption="QM" width="40" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wqm" />
                    <DxColumn data-field="wow" caption="OW" width="40" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wow" />
                    <DxColumn data-field="wcl" caption="CL" width="40" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wcl" />
                    <DxColumn data-field="wmk" caption="MK" width="40" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wmk" />
                  </DxColumn>
                  <template #LQC="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                  </template>
                  <template #wqm="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                  </template>
                  <template #wow="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                  </template>
                  <template #wcl="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                  </template>
                  <template #wmk="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.insResYn === 'Y' ? true : false"
                                :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                  </template>

                  <DxColumn data-field="fileYn" width="100" data-type="string" header-cell-template="Before" cell-template="fileYn" alignment="center" :allow-editing="false"/>
                  <template #Before >
                    <div>Attach<br>file(Before)</div>
                  </template>
                  <template #fileYn="{ data }">
                    <div>
                      <div v-if="data.value === 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="openFile(data)" >
                          Open
                          <v-icon color="blue">$folder</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="data.value != 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn  pt-1" @click="openFile(data)" >
                          Preview
                          <v-icon color="blue">$folder</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </template>

                  <DxColumn data-field="aftFileYn" width="100" data-type="string" header-cell-template="After" cell-template="aftFileYn" alignment="center" :allow-editing="false"/>
                  <template #After >
                    <div>Attach<br>file(After)</div>
                  </template>
                  <template #aftFileYn="{ data }">
                    <div>
                      <div v-if="data.value === 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="openFile(data)" >
                          Open
                          <v-icon color="blue">$folder</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="data.value != 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn  pt-1" @click="openFile(data)" >
                          Preview
                          <v-icon color="blue">$folder</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </template>

                  <DxColumn data-field="fbYn" width="100" data-type="string" header-cell-template="report" cell-template="fbYn" alignment="center" :allow-editing="false"/>
                  <template #report >
                    <div>Comment<br>report</div>
                  </template>
                  <template #fbYn="{ data }">
                    <div>
                      <div v-if="data.value === 'Y'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="openFile(data)" >
                          Preview
                          <v-icon color="blue">$folder</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="data.value != 'Y'"></div>
                    </div>
                  </template>

                  <DxPaging :enabled="true" :page-size="16" />
                  <DxPager :visible="true" :showInfo="false" />
                </DxDataGrid>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="12" class="subText">Count Total: {{ listSize }} Row(s)</v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
    <v80a1040Pop :showPop.sync="showPop" :popupData="popupData" @fileSave="fileSave($event)"/>
    <v80o1020Pop :showPop2.sync="showPop2" :popupData="popupData" @fileSave="fileSave2($event)"/>
    <v80o1020AftPop :showPop3.sync="showPop3" :popupData="popupData" @fileSave="fileSave2($event)"/>
    <v80o1020MakePop :makePop.sync="makePop" :popupData="makePopData"
                     :inspKindListPop="inspKindList2"
                     :insTimeListPop="insTimeList"
                     :empLqcListPop="empLqcList"
                     :supNameListPop="supNameList"
                     :qmPartListPop="qmPartList"
                     :inspLocListPop="inspLocList"
    />
    <v80o1020MakePop2  :makePop2.sync="makePop2" :popupData="makePopData"
                      :inspKindListPop="inspKindList"
                      :insTimeListPop="insTimeList"
                      :empLqcListPop="empLqcList"
                      :supNameListPop="supNameList"
                      :qmPartListPop="qmPartList"
                      :inspLocListPop="inspLocList"
                      @makeSave="makeSave($event)"
    />
   <!--  <v80o1020MakePop2 v-if="makePop2" :makePop2.sync="makePop2" :popupData="makePopData"
                      :inspKindListPop="inspKindList2"
                      :insTimeListPop="insTimeList"
                      :empLqcListPop="empLqcList"
                      :supNameListPop="supNameList"
                      :qmPartListPop="qmPartList"
                      :inspLocListPop="inspLocList"
                      @makeSave="makeSave($event)"
    /> -->
    <v80o1020BomPop :bomPop.sync="bomPop" :popupData="bomPopData"/>
    <v80o1020PrintPop :printPop.sync="printPop" :popupData="printPopData" :pageListPop="pageList"/>
    <v80o1020ReInspPop :reInspPop.sync="reInspPop" :popupData="reInspPopData"
                       :insTimeListPop="insTimeList"
                       :shipNoListPop="shipNoList"
                       :supNameListPop="supNameList"
                       @reInsp="reInsp($event)"
    />
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getSupplier , getV80ShipNo , getRespMaker } from '@/api/view/hip/8/v80a1040.js'
import { v80InspRes , getInspKind , v80o1020List , v80o1020Update , v80o1020Delete } from '@/api/view/hip/8/v80o1020.js'
import { showPageList } from '@/api/view/hip/8/v80o1020Popup.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getDateFormat , getCurrentDate , lpad } from '@/utils/common.js'
import dayjs from 'dayjs'
import notify from 'devextreme/ui/notify' // message
import v80a1040Pop from '@/views/hip/8/popup/v80a1040Pop'
import v80o1020Pop from '@/views/hip/8/popup/v80o1020Pop'
import v80o1020AftPop from '@/views/hip/8/popup/v80o1020AftPop'
import v80o1020MakePop from '@/views/hip/8/popup/v80o1020MakePop'
import v80o1020MakePop2 from '@/views/hip/8/popup/v80o1020MakePop2'
import v80o1020BomPop from '@/views/hip/8/popup/v80o1020BomPop'
import v80o1020PrintPop from '@/views/hip/8/popup/v80o1020PrintPop'
import v80o1020ReInspPop from '@/views/hip/8/popup/v80o1020ReInspPop'
import { reportView} from '@/api/view/hip/common/common.js'
import { getLqcMember } from '@/api/view/hip/8/v80a1040.js'

export default {
  name: 'v80o1020',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    "i-card-top": iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxPager,
    v80a1040Pop,
    v80o1020Pop,
    v80o1020AftPop,
    v80o1020MakePop,
    v80o1020MakePop2,
    v80o1020BomPop,
    v80o1020PrintPop,
    v80o1020ReInspPop
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve', 'btnMakeInspectionRequest', 'btnPrintSheet', 'btnReInspectionApply', 'btnSaveRequest', 'btnDelete'],
      v80a1080Ref: 'v80a1080Ref',
      gridMainList: [],
      setBtnColor: 'setBtnColor',

      stDate: '',

      supName: '',
      supNameList: [],
      inspDiv: '',
      inspDivList: [],
      shipNo: '',
      shipNoList: [],
      blockNo: '',
      qmPart: '',
      qmPartList: [],

      custCd: '',
      respCd: '',

      listSize: 0,

      insTimeList: [],
      empLqcList: [],

      kindInspList:[],
      attendInsp: '',
      attendInspList:[],
      inspLocList:[],

      resultInsp: '',
      resultInspList: [],

      inspKind: '',
      inspKindList: [],
      inspKindList1: [],
      inspKindList2: [],
      searchInfo: null,

      showPop: false,
      showPop2: false,
      showPop3: false,
      popupData: [],
      respCd: '',

      makePop: false,
      makePop2: false,
      makePopData: [],

      bomPop: false,
      bomPopData: [],

      printPop: false,
      printPopData: [],

      pageList: [],

      reInspPop: false,
      reInspPopData: [],

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.v80a1080Ref)
    },
  },
  beforeMount(){
    let params = {
      makerCd: this.$store.state.user.makerCd,
      code: '',
      codegr: '',
      prtCode: 'TIME_INSP',
      userFlag: 'Y',
    }
    //inspTimeList
    Promise.all([
      getCmChildCode(params)]).then(res => {
      res[0].list.forEach(e => {
        if(e.codeName != null){
          e.timeNm = e.codeName.substring(0,2) + ':' +  e.codeName.substring(2)
        } else {
          e.timeNm = ''
        }
      });
      this.insTimeList = res[0].list
    }).catch(error => {})
  },
  mounted() {
    this.init()
    this.gridMainInstance.option('defaultPaging', false)
  },
  methods: {
    getStrFormat(date) {
      this.stDate = date
      return getDateFormat(date)
    },
    init(){
      let toDay = new Date
      toDay.setDate(toDay.getDate() + 1);
      this.stDate = toDay

      this.getList()
      this.getInspKindtList()

      if (this.$store.state.user.userGrd !== 'A'){
					this.supNameChange()
			}
    },
    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          // makerCd: this.$store.state.user.userGrd !== 'A' ? this.custCd : '%',
          makerCd: this.$store.state.user.userGrd !== 'A' ? this.$store.state.user.makerCd : '%',
          code: '',
          codegr: '',
          prtCode: 'INSP_DIV',
          userFlag: 'Y',
          shipGu: ''
        }
        let params2 = {
          code: '',
          codegr: '',
          prtCode: 'QM_PART',
          userFlag: 'Y'
        }
        let params3 = {
          code: '',
          codegr: '',
          prtCode: 'ATTEND_INSP',
          userFlag: 'Y'
        }
        let params4 = {
          code: '',
          codegr: '',
          prtCode: 'KIND_CD',
          userFlag: 'Y'
        }
        let params5 = {
          code: '',
          codegr: '',
          prtCode: 'INSP_LOC',
          userFlag: 'Y'
        }
        // console.log('Customer: ' + this.$store.state.user.makerCd)

        await getSupplier(params).then(res => {
          // this.supNameList.push('Select Supplier')
          if (this.$store.state.user.userGrd == 'A') {
            this.supNameList.push('Select Supplier')
          }       
          res.list.forEach(e => {
            this.supNameList.push(e.custCd + ' : ' + e.custNm)
          });
          this.supName = this.supNameList[0]
          
        })
       
        await getCmChildCode(params).then(res => {
          res.list.forEach(e => {
            this.inspDivList.push(e)
          });
          this.inspDiv = this.inspDivList[0]
        })

        getV80ShipNo(params).then(res => {
          this.shipNoList.push('Select...')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0]
        })

        getCmChildCode(params2).then(res => {
          this.qmPartList.push({codeName: 'Select...' , code: ''})
          res.list.forEach(e => {
            this.qmPartList.push(e)
          });
          this.qmPart = this.qmPartList[0]
        })

        getCmChildCode(params3).then(res => {
          res.list.forEach(e => {
            if(!e.codeName){
              e.codeName = ''
            }
          });
          this.attendInspList = res.list
          this.attendInsp = this.attendInspList[0]
        })

        v80InspRes(params3).then(res => {
          let list = []
          res.list.forEach(e => {
            if(e != null){
              list.push({insResNm: e.insResCd + ': ' + e.insResNm , insResCd: e.insResCd})
            } else {
              list.push({insResNm: '', insResCd: ''})
            }
          });
          this.resultInspList = list
          this.resultInsp = this.resultInspList[0]
        })

        getCmChildCode(params4).then(res => {
          this.inspKindList2.push({code: '' , codeName: 'Select...'})
          res.list.forEach(e => {
            this.inspKindList2.push(e)
          });
        })

        getCmChildCode(params5).then(res => {
          this.inspLocList.push({code: '' , codeName: ''})
          res.list.forEach(e => {
            this.inspLocList.push(e)
          });
        })

      } finally {
        this.endLoading()
      }
    },
    async getInspKindtList(){

      let param = {
        qmPart: !this.qmPart.code ? '' : this.qmPart.code
       
      }
      console.log("QM Part 1020: ", param)
      await getInspKind(param).then(res => {
        this.inspKindList = []  
        this.inspKindList.push({kindCd: '%' , kindNm: 'Select..' })
        res.list.forEach(e => {
          // this.inspKindList.push(e)

          if(e != null){
            this.inspKindList.push({kindNm: e.kindCd + ': ' + e.kindNm , kindCd: e.kindCd})
          } else {            
            this.inspKindList.push({kindNm: '', kindCd: ''})
          }

        });
 
        this.inspKind = this.inspKindList[0]
      })
    },
    async getMainList(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo: this.shipNo == 'Select...' ? '' : this.shipNo,
          makerCd: this.custCd,
          inspDiv: !this.inspDiv.code ? '' : this.inspDiv.code,
          stDate: dayjs(this.stDate).format('YYYY-MM-DD'),
          qmPart: !this.qmPart.code ? '' : this.qmPart.code,
          insRes: !this.resultInsp.insResCd ? '' : this.resultInsp.insResCd,
          itemInfo: !this.searchInfo ? '' : this.searchInfo,
          attendInsp: !this.attendInsp.code ? '' : this.attendInsp.code,
          kindCd: !this.inspKind.kindCd ? '' : this.inspKind.kindCd
        }
        await v80o1020List(params).then(res => {
          let cnt = 1;
          res.list.forEach(e => {
            e.selChek = false
            e.id = cnt++
            e.porNoSeq = (!e.porNo ? '' : e.porNo ) + '-' + (!e.porSeq ? '' : e.porSeq)
            e.itemDesc = (!e.itemDesc ? '' : e.itemDesc ) + ' ( ' + (!e.block ? '' : e.block) + ' )'
          });
          this.gridMainList = res.list
          this.listSize = res.list.length
        })

      } finally {
        this.endLoading()
      }
    },
    supNameChange(){
      let supNameGbn = this.supName
      if(supNameGbn === 'Select Supplier'){
        this.custCd = ''
      } else {
        supNameGbn = supNameGbn.split(' : ')
        this.custCd = supNameGbn[0]
      }

      if(this.$store.state.user.userGrd !== 'A'){
        this.custCd = this.$store.state.user.makerCd
      }

      let params = {
        makerCd: this.custCd
      }
     
      getLqcMember(params).then(res => {
        this.empLqcList.push({empNo: '' , enm: 'Select LQC..'})
        res.list.forEach(e => {
          this.empLqcList.push(e)
        });
      })
    },
    uppercase(){
      if(!this.porNo){
        this.porNo = this.porNo.toUpperCase()
      }
    },
    btnRetrieve(){
      this.getMainList()
    },
    btnMakeIns(){
      this.makePopData = []
      if(!this.custCd){
        this.vToastify(this.$t('Please, select a Sub-Contract!!'), 'warn')
        return
      }
      if(this.shipNo === null || this.shipNo === 'Select...'){
        this.vToastify(this.$t('Please, select a Ship No!!'), 'warn')
        return
      }
      if(!this.qmPart.code){
        this.vToastify(this.$t('Please, select a QM Part!!'), 'warn')
        return
      }
     
      this.makePopData.shipNo = this.shipNo
      this.makePopData.custCd = this.custCd
      this.makePopData.qmPart = this.qmPart
      this.makePopData.stDate = this.stDate
      this.makePopData.inspDiv = this.inspDiv
      this.makePopData.supName = this.supName
      if(this.custCd === '14017' || this.custCd === '12994'){
        this.makePop = true
      } else {
        this.makePop2 = true
      }
    },
    request(e){
      let filter = []
      filter = e.custCd.split(' : ')

      this.shipNo = e.shipNo
      this.custCd = filter[0]
      this.inspDiv = e.inspDiv
      this.qmPart = e.qmPart
      this.stDate = e.stDate
      this.ndtKind = e.ndtKind
      this.wkKind = e.wkKind
      this.getMainList()
    },
    onEditingStart(e){
      if(e.data.insResYn === 'Y' && (e.column.dataField === 'insDate' || e.column.dataField === 'insTime' || e.column.dataField === 'kindCd' || e.column.dataField === 'porQty')){
        e.cancel = true
      }
    },
    async onValueChanged(value, cellInfo){
      if(cellInfo.rowType === 'header') {
        for(let i = 0; i < this.gridMainList.length; i++) {
          let insResYn = await this.gridMainInstance.byKey(i+1)
          if(insResYn.insResYn != 'Y'){
            this.gridMainList[i].selChek = value.value
            if(value.value) {
              this.gridMainInstance.selectRows(i+1 , true)
            } else {
              this.gridMainInstance.deselectAll()
            }
          }
        }
      } else {
        this.gridMainList[cellInfo.rowIndex].selChek = value.value
        if(value.value) {
          this.gridMainInstance.selectRows(cellInfo.rowIndex + 1, true)
        } else {
          this.gridMainInstance.deselectRows(cellInfo.rowIndex + 1)
        }
      }
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '1px'
        if(e.data.insResYn === 'Y' && (e.column.dataField === 'insDate' || e.column.dataField === 'insTime' || e.column.dataField === 'kindCd' || e.column.dataField === 'porQty')){
          e.cellElement.classList.add('cancel-editable-cell')
        }
      }
    },
    bomClick(e){
      this.bomPopData.shipNo = e.data.shipNo
      this.bomPopData.porNo = !e.data.porNo ? '' : e.data.porNo
      this.bomPopData.porSeq = !e.data.porSeq ? '' : e.data.porSeq
      this.bomPopData.makerCd = !e.data.makerCd ? '' : e.data.makerCd
      this.bomPopData.inspAct = !e.data.inspAct ? '' : e.data.inspAct
      this.bomPopData.revNo = !e.data.revNo ? '' : e.data.revNo
      this.bomPopData.reqDate = dayjs(this.stDate).format('YYYY-MM-DD')
      this.bomPop = true
    },
    onValueChanged2(value, cellInfo){
      cellInfo.component.cellValue(cellInfo.rowIndex, cellInfo.columnIndex, cellInfo.value === 'Y' ? 'N' : 'Y')
      cellInfo.component.updateDimensions()
    },
    async openFile(e){
      let params = {
        makerCd: e.data.makerCd
      }
      await getRespMaker(params).then(res => {
        this.respCd = res.list[0].respCd
      })

      this.popupData.reqDate = e.data.reqDate
      this.popupData.inspAct = e.data.inspAct
      this.popupData.makerCd = e.data.makerCd
      this.popupData.shipNo = e.data.shipNo
      this.popupData.revNo = e.data.revNo
      this.popupData.qmPart = {code: e.data.qmPart , codeName: e.data.qmNm}
      this.popupData.clsCd = e.data.clsCd
      this.popupData.cmtSeq = e.data.cmtSeq
      this.popupData.respCd = this.respCd
      this.popupData.inspDiv = this.inspDiv
      this.popupData.insRes = {insResCd: '' , insResNm: '' }
      this.popupData.kindCd = {kindCd: '' , kindNm: ''}
      this.popupData.supName = {kindCd: '' , kindNm: ''}

      //popup open
      if(e.column.dataField === 'fileYn'){
        if(e.data.makerCd =='14017' || e.data.makerCd =='12994' ){
          this.showPop = true
        } else {
          this.showPop2 = true
        }
      }else if(e.column.dataField === 'aftFileYn'){
        this.showPop3 = true
      }else{
        const param = {
          fileName: 'v80o1020_cmt_sheet.jrxml',
          as_ship_no: this.shipNo,
          as_cls_cd: e.clsCd,
          as_cmt_seq: e.cmtSeq
        }
        this.openLoading('searching')
        reportView(param)
            .finally(() => {
              this.endLoading()
            })
      }
    },
    fileSave(){
      // this.getMainList()
    },
    fileSave2(e){
      // this.shipNo = ''
      this.shipNo = e.shipNo
      this.custCd = e.makerCd
      // this.inspDiv = e.inspDiv
      this.stDate = e.reqDate
      // this.qmPart = e.qmPart
      // this.resultInsp = e.insRes
      // this.inspKind = e.kindCd

      this.getMainList()
    },
    makeSave(e){

      this.supName = e.supName
      // this.inspDiv = e.inspDiv
      this.stDate = e.stDate
      this.shipNo = e.shipNo
      // this.qmPart = e.qmPart

      // this.makePop2 = false
      this.getMainList()
    },
    reInsp(e){
      this.supName = e.supName
      // this.inspDiv = e.inspDiv
      this.stDate = e.stDate
      this.shipNo = e.shipNo
      // this.kindCd = e.kindCd
      // this.qmPart = e.qmPart
      // this.attendInsp = e.attendInsp

      this.reInspPop = false
      this.getMainList()
    },
    async btnPrintSheet(){
      if(!this.custCd){
        this.vToastify(this.$t('Please, select a Sub-Contract!!'), 'warn')
        return
      }
      if(this.shipNo === null || this.shipNo === 'Select...'){
        this.vToastify(this.$t('Please, select a Ship No!!'), 'warn')
        return
      }
      if(!this.qmPart.code){
        this.vToastify(this.$t('Please, select a QM Part!!'), 'warn')
        return
      }

      this.printPopData.inspDiv = !this.inspDiv.code ? '' : this.inspDiv.code
      this.printPopData.stDte = dayjs(this.stDate).format('YYYY-MM-DD')
      this.printPopData.makerCd = this.custCd
      this.printPopData.shipNo = this.shipNo
      this.printPopData.qmPart = !this.qmPart.code ? '' : this.qmPart.code
      this.printPopData.insRes = !this.resultInsp.resultInspCd ? '' : this.resultInsp.resultInspCd
      this.printPopData.itemInfo = !this.searchInfo ? '' : this.searchInfo
      this.printPopData.attendInsp = !this.attendInsp.code ? '' : this.attendInsp.code
      this.printPopData.kindCd = !this.inspKind.kindCd ? '' : this.inspKind.kindCd
      this.printPopData.inspLoc = ''
      this.printPopData.pageNum = '1'

      let param = {
        inspDiv: !this.inspDiv.code ? '' : this.inspDiv.code,
        stDte: dayjs(this.stDate).format('YYYY-MM-DD'),
        makerCd: this.custCd,
        shipNo: this.shipNo,
        qmPart: !this.qmPart.code ? '' : this.qmPart.code,
        insRes: !this.resultInsp.resultInspCd ? '' : this.resultInsp.resultInspCd,
        itemInfo: !this.searchInfo ? '' : this.searchInfo,
        attendInsp: !this.attendInsp.code ? '' : this.attendInsp.code,
        kindCd: !this.inspKind.kindCd ? '' : this.inspKind.kindCd,
        inspLoc: '',
      }

      await showPageList(param).then(res => {
        this.pageList = []
        res.list.forEach(e => {
          this.pageList.push(e.pageNum)
        });
      })

      let gbn = ''
      if(this.pageList.length === 1){
        // if(this.param.qmPart == 'P'){

        if (this.qmPart.code == "P") {
          if(this.custCd === '13443'){
            gbn = 'v80o1020_prt_app_pnt_13443.jrxml'
          }else if(this.custCd === '90263'){
            gbn = 'v80o1020_prt_app_pnt_90263.jrxml'
          }else if(this.custCd === '92699'){
            gbn = 'v80o1020_prt_app_pnt_92699.jrxml'
          }else {
            gbn = 'v80o1020_prt_app_pnt.jrxml'
          }
        }else {
          if(this.custCd === '90263' || this.custCd === '92699'){
            gbn = 'v80o1020_prt_app_new.jrxml'
          }else if(this.custCd === '14017' || this.custCd === '12994'){
            gbn = 'v80a1040.jrxml'
          }else {
            gbn = 'v80o1020_prt_app.jrxml'
          }
        }
        const report = {
          fileName: gbn,
          as_cust_cd: this.custCd,
          as_qm_part: !this.qmPart.code ? '' : this.qmPart.code,
          as_ship_no: this.shipNo,
          as_st_date: dayjs(this.stDate).format('YYYY-MM-DD'),
          as_insp_div: !this.inspDiv.code ? '' : this.inspDiv.code,
          as_item_info: !this.searchInfo ? '' : this.searchInfo,
          as_attend_insp: !this.attendInsp.code ? '' : this.attendInsp.code,
          as_kind_cd: !this.inspKind.kindCd ? '' : this.inspKind.kindCd,
          as_insp_loc: '',
          as_page_num: '1',
        }
        this.openLoading('searching')
        reportView(report)
            .finally(() => {
              this.endLoading()
            })
      } else {
        this.printPop = true
      }
    },
    async btnReInspectionApply(){
      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()

      if(!selectedMainRows.length){
        this.vToastify(this.$t('Data is not selected.'), 'warn')
        return
      } else if(selectedMainRows.length > 1){
        this.vToastify(this.$t('You select one row to Re-inspection'), 'warn')
        return
      }
      for(var row of selectedMainRows){
        // row.insDate = dayjs(this.stDate).format('YYYY-MM-DD')
        row.insDate = dayjs(row.insDate).format('YYYY-MM-DD')
        row.item = row.itemDesc
        row.supName = this.supName
        row.inspDiv = this.inspDiv
        row.attendInsp = this.attendInsp

        for(let i = 0; i < this.supNameList.length; i++){
          let supNameGbn = this.supNameList[i]
          supNameGbn = supNameGbn.split(' : ')
          if(row.makerCd === supNameGbn[0]){
            row.supName = this.supNameList[i]
          }
        }
      }
      this.reInspPopData = selectedMainRows

      this.vToastifyPrompt(
          this.$t('Do you want to Re-Inspection Apply?'),
          'info',
          current => {
            this.reInspPop = true
          },
          null,
          true
      )
    },
    async btnSaveRequest(){
      let minDate = new Date
      minDate.setDate(minDate.getDate() + 1);
      minDate = dayjs(minDate).format('YYYY-MM-DD')

      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()

      if(!selectedMainRows.length){
        this.vToastify(this.$t('Data is not selected.'), 'warn')
        return
      }

      for(var row of selectedMainRows){
        // row.insDate = dayjs(this.stDate).format('YYYY-MM-DD')
        row.insDate = dayjs(row.insDate).format('YYYY-MM-DD')
        row.block = !row.block ? '' : row.block
        if(!row.insDate){
          this.vToastify(this.$t('Select Inspection Date.'), 'warn')
          return
        }
        if(!row.insTime){
          this.vToastify(this.$t('Select Inspection Time.'), 'warn')
          return
        }
      }
      try {
        this.openLoading('searching')

        v80o1020Update(selectedMainRows).then(res => {
          if(res.body == 'Y'){
            notify(this.$t('Request Inspection Update is complted.'), 'success', 3000)
          }else {
            this.vToastify(this.$t('An error has been occured while update data :'), 'warn')
          }
          this.getMainList()
        })
            .catch(error => {
              this.endLoading()
            })
      }finally {
        this.endLoading()
      }
    },
    async btnDelete(){      

      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()

      if(!selectedMainRows.length){
        this.vToastify(this.$t('Data is not selected.'), 'warn')
        return
      }

      let fcnt = 0
      for(var row of selectedMainRows){
        if(row.fileYn === 'Y' || row.aftFileYn === 'Y'){
          fcnt++
        }
        row.insRes = !row.insRes ? '' : row.insRes
      }
      if(fcnt > 0){
        this.vToastify(this.$t('Some Item inspection already exists attachment file! You must Delete attach file the first!'), 'warn')
        return
      }

      try {
        this.openLoading('searching')
        this.vToastifyPrompt(
            this.$t('Do you want to delete the data?'),
            'info',
            current => {
              // console.log("yes", selectedMainRows)
              v80o1020Delete(selectedMainRows).then(res => {
                
                if(res.body === 'OK'){
                  notify(this.$t('Deleting data is completed.'), 'success', 3000)
                } else {
                  this.vToastify(this.$t('An error has been occured while deleting data.'), 'warn')
                }
                this.getMainList()
              })
                  .catch(error => {
                    this.vToastify(error, 'warn')
                  })
            },
            null,
            true
        )
      } finally {
        this.endLoading()
      }
    },
    manual(){
      var param = 'http://ibiz.hvs.com.vn/notice/User_manual.pdf'
      window.open(param)
    }
  }
}
</script>
<style lang="scss" scoped>
.subText{
  font-weight: bold;
  color: black;
}

$redBtn: #FF0000;
.setBtnColor::v-deep {
  [role=btnDelete]{
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
}
.userManual {
  background-color: yellow;
  border: 1px solid red;
  font-weight: bold;
  cursor: pointer;
}
.userManual:hover{
  color: #4980BC;
}
.inspection {
  background-color: #00FF00;
  border: 1px solid red;
  font-weight: bold;
}
.bomClick {
  font-weight: bold;
  cursor: pointer;
}
.bomClick:hover{
  color: #4980BC;
}
</style>